<template>
    <transition name="fade">
        <div v-show="true" class="fixed left-0 top-0 z-40 flex h-dvh w-dvw bg-theme-bg" :style="topStyle">
            <div class="h-full w-dvw">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        topStyle() {
            return `top:${this.ui.headerbar.offsetHeight}px`;
        },
    },
};
</script>
